"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandwritingCraftsmanshipEvaluator = void 0;
const BasicAnalysisEngine_1 = require("../engines/BasicAnalysisEngine");
const GeminiHandwritingEngine_1 = require("../engines/GeminiHandwritingEngine");
class HandwritingCraftsmanshipEvaluator {
    basicEngine;
    geminiEngine;
    constructor(basicEngine = new BasicAnalysisEngine_1.BasicAnalysisEngine(), geminiEngine = new GeminiHandwritingEngine_1.GeminiHandwritingEngine()) {
        this.basicEngine = basicEngine;
        this.geminiEngine = geminiEngine;
    }
    async evaluate(submission, activity) {
        const engineType = activity.config.engineType ?? 'basic';
        const strokes = submission.strokes ?? [];
        const targetText = submission.finalText ?? String(activity.config.targetText ?? '');
        let analysis;
        if (engineType === 'gemini') {
            analysis = await this.geminiEngine.analyzeCraftsmanship(strokes, targetText);
        }
        else {
            analysis = await this.basicEngine.analyzeCraftsmanship(strokes, targetText);
        }
        const score = analysis?.score ?? 0;
        const feedback = analysis?.feedback ?? 'No analysis available.';
        const suggestions = analysis?.suggestions ?? [];
        const details = analysis?.details ?? {};
        return {
            score,
            maxScore: 100,
            feedback,
            breakdown: [
                {
                    name: 'Neatness',
                    score,
                    maxScore: 100,
                    feedback: suggestions[0] ?? 'Handwriting analysis complete',
                },
            ],
            skills: [{ key: 'handwriting:craftsmanship', label: 'Handwriting Craftsmanship' }],
            label: 'Neatness Score',
        };
    }
}
exports.HandwritingCraftsmanshipEvaluator = HandwritingCraftsmanshipEvaluator;
